// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._15a5nqa1{border-top-style:solid}\n._19bvpxbi{padding-left:var(--ds-space-200,1pc)}\n._1i53b5v6{border-top-color:var(--ds-border,#dfe1e6)}\n._ca0qutpp{padding-top:var(--ds-space-150,9pt)}\n._n3tdutpp{padding-bottom:var(--ds-space-150,9pt)}\n._syaz131l{color:var(--ds-text-subtlest,#626f86)}\n._u5f3pxbi{padding-right:var(--ds-space-200,1pc)}\n._uwhke4h9{border-top-width:var(--ds-border-width,1px)}", ""]);
// Exports
module.exports = exports;
